export const newPriceData = [
  {
    type: "b2c",
    typeDesc: "price.b2cTip",
    marks: {
      1: 1000,
      2: 2500,
      3: 5000,
      4: 10000,
      5: "10000+",
      // 5: 20000,
      // 6: "20000+",
    },
    min: 1,
    max: 5,

    developer: [
      {
        min: 1,
        max: 1000,
        priceByMonth: 99,
        priceByYear: 990,
        originalPrice: 1188,
        disable: false,
      },
      {
        min: 1000,
        max: 2500,
        priceByMonth: 248,
        priceByYear: 2475,
        originalPrice: 2970,
        disable: false,
      },
      {
        min: 2500,
        max: 5000,
        priceByMonth: 495,
        priceByYear: 4950,
        originalPrice: 5940,

        disable: false,
      },
      {
        min: 5000,
        max: 10000,
        priceByMonth: 990,
        priceByYear: 9900,
        originalPrice: 11880,
        disable: false,
      },
      {
        min: 10000,
        max: "10000+",
        priceByMonth: "contact",
        priceByYear: "contact",
        originalPrice: "contact",
        disable: false,
      },
      // { min: "--", max: "--", price: 1980, disable: true },
    ],
    developerPro: [
      {
        min: 1,
        max: 1000,
        priceByMonth: 990,
        priceByYear: 9900,
        originalPrice: 11880,
        disable: false,
      },
      {
        min: 1000,
        max: 2500,
        priceByMonth: 2099,
        priceByYear: 20990,
        originalPrice: 25188,
        disable: false,
      },
      {
        min: 2500,
        max: 5000,
        priceByMonth: 3899,
        priceByYear: 38990,
        originalPrice: 46788,
        disable: false,
      },
      {
        min: 5000,
        max: 10000,
        priceByMonth: 6899,
        priceByYear: 68990,
        originalPrice: 82788,
        disable: false,
      },
      {
        min: 10000,
        max: "10000+",
        priceByMonth: "contact",
        priceByYear: "contact",
        originalPrice: "contact",
        disable: false,
      },
      // { min: 50000, max: 100000, price: 42999, disable: false },
    ],
    features: {
      developer: [
        "price.priceList.b2c.develop.function.item1",
        "price.priceList.b2c.develop.function.item2",
        "price.priceList.b2c.develop.function.item3",
      ],
      developerPro: [
        "price.priceList.b2c.developPro.function.item1",
        "price.priceList.b2c.developPro.function.item2",
        "price.priceList.b2c.developPro.function.item3",
        "price.priceList.b2c.developPro.function.item4",
        "price.priceList.b2c.developPro.function.item5",
        "price.priceList.b2b.developPro.function.item6",
      ],
      enterprise: [
        "price.priceList.b2c.enterprise.function.item1",
        "price.priceList.b2c.enterprise.function.item2",
        "price.priceList.b2c.enterprise.function.item3",
        "price.priceList.b2c.enterprise.function.item4",
        "price.priceList.b2c.enterprise.function.item5",
        {
          title: "price.priceList.b2c.enterprise.function.item6",
          link: "/solutions/private-cloud",
          tag: true,
        },
      ],
    },
  },
  {
    type: "b2b",
    typeDesc: "price.b2bTip",
    marks: {
      1: 500,
      2: 1000,
      3: "1000+",
    },
    min: 1,
    max: 3,

    developer: [
      {
        min: 1,
        max: 500,
        priceByMonth: 2999,
        priceByYear: 29990,
        originalPrice: 35988,
        disable: false,
      },
      {
        min: 500,
        max: 1000,
        priceByMonth: 4799,
        priceByYear: 47990,
        originalPrice: 57588,
        disable: false,
      },
      {
        min: 1000,
        max: "1000+",
        priceByMonth: "contact",
        priceByYear: "contact",
        originalPrice: "contact",
        disable: false,
      },
    ],
    developerPro: [
      {
        min: 1,
        max: 500,
        priceByMonth: 4999,
        priceByYear: 49990,
        originalPrice: 59988,
        disable: false,
      },
      {
        min: 500,
        max: 1000,
        priceByMonth: 8999,
        priceByYear: 89990,
        originalPrice: 107880,
        disable: false,
      },
      {
        min: 1000,
        max: "1000+",
        priceByMonth: "contact",
        priceByYear: "contact",
        originalPrice: "contact",
        disable: false,
      },
    ],
    features: {
      developer: [
        {
          title: "price.priceList.b2b.develop.function.item1",
          des: "price.priceList.b2b.develop.function.item1.description",
        },

        "price.priceList.b2b.develop.function.item2",
        "price.priceList.b2b.develop.function.item3",
        "price.priceList.b2b.develop.function.item4",
      ],
      developerPro: [
        {
          title: "price.priceList.b2b.developPro.function.item1",
          des: "price.priceList.b2b.developPro.function.item1.description",
        },

        "price.priceList.b2b.developPro.function.item2",
        "price.priceList.b2b.developPro.function.item3",
        "price.priceList.b2b.developPro.function.item4",
        "price.priceList.b2b.developPro.function.item5",
        "price.priceList.b2b.developPro.function.item6",
      ],
      enterprise: [
        "price.priceList.b2b.enterprise.function.item1",
        "price.priceList.b2b.enterprise.function.item2",
        "price.priceList.b2b.enterprise.function.item3",
        "price.priceList.b2b.enterprise.function.item4",
        "price.priceList.b2b.enterprise.function.item5",
        {
          title: "price.priceList.b2c.enterprise.function.item6",
          link: "/solutions/private-cloud",
          tag: true,
        },
      ],
    },
  },
  {
    type: "b2e",
    typeDesc: "price.b2eTip",
    marks: {
      1: 50,
      2: 100,
      3: "100+",
      // 3: 150,
      // 4: 200,
      // 5: "200+",
    },
    min: 1,
    max: 3,

    developer: [
      {
        min: 1,
        max: 50,
        priceByMonth: 699,
        priceByYear: 6990,
        originalPrice: 8388,
        disable: false,
      },
      {
        min: 50,
        max: 100,

        priceByMonth: 1099,
        priceByYear: 10990,
        originalPrice: 13188,

        disable: false,
      },
      {
        min: 200,
        max: "200+",
        priceByMonth: "contact",
        priceByYear: "contact",
        originalPrice: "contact",
        disable: false,
      },
    ],
    features: {
      developer: [
        "price.priceList.b2e.develop.function.item1",
        "price.priceList.b2e.develop.function.item2",
        "price.priceList.b2e.develop.function.item3",
        "price.priceList.b2e.develop.function.item4",
        "price.priceList.b2e.develop.function.item5",
        "price.priceList.b2e.develop.function.item6",
      ],
      enterprise: [
        "price.priceList.b2e.enterprise.function.item1",
        "price.priceList.b2e.enterprise.function.item2",
        "price.priceList.b2e.enterprise.function.item3",
        "price.priceList.b2e.enterprise.function.item4",
        "price.priceList.b2e.enterprise.function.item5",
        {
          title: "price.priceList.b2c.enterprise.function.item6",
          link: "/solutions/private-cloud",
          tag: true,
        },
      ],
    },
  },
];
